import dayjs from "dayjs";
import localeEs from "dayjs/locale/es";
import localeFi from "dayjs/locale/fi";
import localeJa from "dayjs/locale/ja";
import localeNlBe from "dayjs/locale/nl-be";
import duration from "dayjs/plugin/duration";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { languages } from "src/config/languages";

i18n
  // load translation using http -> see /public/locales
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    lng: "fi",
    fallbackLng: "en",
    returnEmptyString: false,
    debug: Boolean(import.meta.env.DEV),
    nsSeparator: ">>",
    keySeparator: "::",
  });

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
  setDayjsLocale(lng);
});

dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

// Register the locale data every language in `languages` maps to. Registered
// explicitly rather than by `import "dayjs/locale/fi"`, whose side effect lands
// on a second dayjs copy under Vite pre-bundling. "en" needs no registration:
// localizedFormat already carries its formats.
for (const locale of [localeEs, localeFi, localeJa, localeNlBe]) {
  dayjs.locale(locale, undefined, true);
}

/** Points dayjs at the locale data for an i18n language code. */
export function setDayjsLocale(lng: string) {
  const languageConfig = languages.find((lang) => lang.code === lng);
  const dayjsLocale = languageConfig?.dayjsCode || "en";
  dayjs.locale(dayjsLocale);
}

export default i18n;
